export const FlowLines = ({ className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 1440 900"
    preserveAspectRatio="xMidYMid slice"
    className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
  >
    <defs>
      <linearGradient id="goldFlow" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#D4AF37" stopOpacity="0" />
        <stop offset="30%" stopColor="#E6C687" stopOpacity="0.85" />
        <stop offset="60%" stopColor="#D4AF37" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#D4AF37" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g opacity="0.5" style={{ filter: "blur(7px)" }}>
      <path d="M-120,640 C260,470 520,800 880,610 S1360,380 1620,540" fill="none" stroke="url(#goldFlow)" strokeWidth="1.6" />
      <path d="M-120,300 C300,420 620,180 980,320 S1400,520 1620,380" fill="none" stroke="url(#goldFlow)" strokeWidth="1.2" />
    </g>
    <path className="flow-line" d="M-120,640 C260,470 520,800 880,610 S1360,380 1620,540" fill="none" stroke="url(#goldFlow)" strokeWidth="1.1" opacity="0.55" />
    <path className="flow-line" style={{ animationDuration: "38s" }} d="M-120,300 C300,420 620,180 980,320 S1400,520 1620,380" fill="none" stroke="url(#goldFlow)" strokeWidth="0.9" opacity="0.4" />
    <path className="flow-line" style={{ animationDuration: "46s", animationDirection: "reverse" }} d="M-120,820 C360,700 700,880 1040,740 S1480,560 1640,680" fill="none" stroke="url(#goldFlow)" strokeWidth="0.8" opacity="0.3" />
  </svg>
);
